<div class="body">
  <div class="preview-img">
    @if (isDarkTheme()) {
      <img
        ngSrc="/assets/images/pwa/preview-dark.webp"
        srcset="
          /assets/images/pwa/preview-dark.webp     400w,
          /assets/images/pwa/preview@x2-dark.webp  800w,
          /assets/images/pwa/preview-mob-dark.webp 343w
        "
        sizes="(max-width: 600px) 100vw, (min-width: 601px) 50vw"
        [alt]="'shared.common.pwaSetup.preview.alt' | translate"
        height="225"
        width="400"
        priority />
    } @else {
      <img
        ngSrc="/assets/images/pwa/preview-light.webp"
        srcset="
          /assets/images/pwa/preview-light.webp     400w,
          /assets/images/pwa/preview@x2-light.webp  800w,
          /assets/images/pwa/preview-mob-light.webp 343w
        "
        sizes="(max-width: 600px) 100vw, (min-width: 601px) 50vw"
        [alt]="'shared.common.pwaSetup.preview.alt' | translate"
        height="225"
        width="400"
        priority />
    }
  </div>

  <div class="d-flex flex-col">
    @if (isIOS) {
      <p class="title">
        {{ 'shared.common.pwaSetup.ios.title' | translate }}
      </p>
    } @else {
      <p class="title">
        {{ 'shared.common.pwaSetup.otherDevice.title' | translate }}
      </p>
    }
    <p class="subtitle mt-2">
      {{ 'shared.common.pwaSetup.subtitle' | translate }}
    </p>
  </div>

  <div class="d-flex flex-col gap-2">
    @if (isIOS) {
      <p class="step">
        <fu-icon class="step-icon" iconName="apple" size="24" />
        <span>{{ 'shared.common.pwaSetup.ios.step1.text' | translate }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="upload" size="24" />
        <span>{{ 'shared.common.pwaSetup.ios.step2.text' | translate }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="plus-outlined" size="24" />
        <span>{{ 'shared.common.pwaSetup.ios.step3.text' | translate }}</span>
      </p>
    } @else {
      <p class="step">
        <fu-icon class="step-icon" iconName="dots-vertical" size="24" />
        <span>{{
          'shared.common.pwaSetup.otherDevice.step1.text' | translate
        }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="install" size="24" />
        <span>{{
          'shared.common.pwaSetup.otherDevice.step2.text' | translate
        }}</span>
      </p>

      <p class="step">
        <fu-icon class="step-icon" iconName="check-done" size="24" />
        <span>{{
          'shared.common.pwaSetup.otherDevice.step3.text' | translate
        }}</span>
      </p>
    }
  </div>
  @if (canInstallPwa() || isInstalling()) {
    <div class="d-flex flex-col gap-3 justify-center">
      <hr class="divider" />
      <span class="subtitle">{{
        'shared.common.pwaSetup.installBelow.text' | translate
      }}</span>
      <zeusm-button size="m" fullWidth uiType="primary" (click)="installPwa()">
        {{ 'shared.common.pwaSetup.action.install' | translate }}
      </zeusm-button>
    </div>
  }
</div>
